import styled from "styled-components"

const LoginLayout = styled.div`
  display : flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width : 100%;
  height : auto;
  gap : 1rem;
  box-sizing: border-box;
  padding : 5rem 0;
  
  
`

export default LoginLayout